module.exports = __webpack_public_path__ + "static/sap-bd705acd5e64f6d4aa8bf70ee760364a.png";